module.exports = __webpack_public_path__ + "static/scale-model-of-neptune's-park-in-virginia-beach-virginia-e009f3acc85234da0e26802a5c127561.png";